/* ROOTEXO site behaviour. No dependencies. */
(function () {
  'use strict';
  var RX = window.RX || {};
  var KEY_PLAN = 'rx_plan', KEY_LIKES = 'rx_likes';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(k, d) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
  function save(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* analytics */
  function track(name, data) {
    data = data || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'rx_' + name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('rx_' + name, data); } catch (e) {}
    try { if (typeof window.gtag === 'function') gtag('event', 'rx_' + name, data); } catch (e) {}
    try { if (typeof window.fbq === 'function' && name === 'form_submitted') fbq('track', 'Lead', data); } catch (e) {}
  }
  RX.track = track;
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-rx-event]');
    if (el) track(el.getAttribute('data-rx-event'), { label: el.getAttribute('data-rx-label') || el.textContent.trim().slice(0, 60), page: location.pathname });
  });

  /* WhatsApp message */
  var LABELS = RX.labels || {};
  function lab(v) { return LABELS[v] || v; }
  function waMessage(context) {
    var p = load(KEY_PLAN, {}), likes = load(KEY_LIKES, []);
    var lines = ['Hi ROOTEXO,'];
    var space = p.space && p.space !== 'water' && p.space !== 'unsure' ? lab(p.space) : null;
    if (context) lines.push(context);
    else if (space) lines.push("I'm planning landscaping for my " + space.toLowerCase() + '.');
    else lines.push("I'd like to discuss a landscaping project.");
    if (p.city) lines.push('Location: ' + p.city);
    if (p.area && p.area !== 'unsure') lines.push('Approx. area: ' + lab(p.area));
    var interests = (p.want || []).filter(function (w) { return w !== 'unsure'; }).map(lab).concat(likes);
    if (interests.length) { lines.push('Interested in:'); interests.forEach(function (i) { lines.push('\u2022 ' + i); }); }
    if (p.budget) lines.push('Budget: ' + lab(p.budget));
    lines.push("I'd like to discuss a site visit.");
    return lines.join('\n');
  }
  function waHref(context) {
    return 'https://wa.me/' + (RX.wa || '') + '?text=' + encodeURIComponent(waMessage(context));
  }
  RX.waHref = waHref;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-rx-wa]');
    if (!a) return;
    a.href = waHref(a.getAttribute('data-rx-wa') || '');
    track('whatsapp_click', { context: a.getAttribute('data-rx-wa') || 'general', page: location.pathname });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="tel:"]');
    if (a) track('phone_click', { page: location.pathname });
  });

  /* header: mega menu + drawer */
  document.querySelectorAll('[data-rx-mega]').forEach(function (m) {
    var btn = m.querySelector('button');
    function set(o) { if (o) m.setAttribute('data-open', ''); else m.removeAttribute('data-open'); btn.setAttribute('aria-expanded', o); }
    btn.addEventListener('click', function () { set(!m.hasAttribute('data-open')); });
    m.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) set(true); });
    m.addEventListener('mouseleave', function () { if (matchMedia('(hover:hover)').matches) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) { if (!m.contains(e.target)) set(false); });
  });
  var drawer = document.querySelector('[data-rx-drawer]');
  document.querySelectorAll('[data-rx-drawer-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!drawer) return;
      if (!drawer.hasAttribute('data-open')) { drawer.setAttribute('data-open', ''); document.body.style.overflow = 'hidden'; drawer.querySelector('button').focus(); }
      else { drawer.removeAttribute('data-open'); document.body.style.overflow = ''; }
    });
  });
  if (drawer) drawer.addEventListener('click', function (e) { if (e.target.closest('a')) { drawer.removeAttribute('data-open'); document.body.style.overflow = ''; } });

  /* lazy video */
  var vids = document.querySelectorAll('video[data-rx-src]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.src) v.src = v.getAttribute('data-rx-src');
          if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  } else { vids.forEach(function (v) { v.src = v.getAttribute('data-rx-src'); }); }

  /* filters */
  document.querySelectorAll('[data-rx-filter-group]').forEach(function (g) {
    var scope = g.closest('section');
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]'); if (!b) return;
      g.querySelectorAll('[data-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      var f = b.getAttribute('data-filter');
      scope.querySelectorAll('[data-tags]').forEach(function (p) {
        p.hidden = !(f === 'all' || (' ' + p.getAttribute('data-tags') + ' ').indexOf(' ' + f + ' ') > -1);
      });
      track('project_filter', { filter: f });
    });
  });
  document.querySelectorAll('.rx-project').forEach(function (p) {
    p.addEventListener('click', function () { track('project_viewed', { project: p.getAttribute('data-rx-label') }); });
  });

  /* before / after */
  document.querySelectorAll('.rx-ba__frame').forEach(function (f) {
    var r = f.querySelector('input[type=range]'), used = false;
    r.addEventListener('input', function () {
      f.style.setProperty('--pos', r.value + '%');
      if (!used) { used = true; track('before_after_interaction', { item: f.getAttribute('data-rx-label') }); }
    });
  });

  /* planner */
  var planner = document.querySelector('[data-rx-planner]');
  if (planner) (function () {
    var steps = planner.querySelectorAll('.rx-step'), result = planner.querySelector('.rx-result');
    var bars = planner.querySelectorAll('.rx-planner__progress i'), count = planner.querySelector('.rx-planner__stepcount');
    var back = planner.querySelector('[data-back]'), next = planner.querySelector('[data-next]'), nav = planner.querySelector('.rx-planner__nav');
    var map = {}; try { map = JSON.parse(planner.querySelector('script[type="application/json"]').textContent); } catch (e) {}
    var state = load(KEY_PLAN, {}), i = 0, started = false;

    steps.forEach(function (s) {
      var v = state[s.getAttribute('data-name')];
      s.querySelectorAll('input').forEach(function (inp) {
        if (Array.isArray(v) ? v.indexOf(inp.value) > -1 : v === inp.value) inp.checked = true;
      });
    });
    function pick(name, val) { var el = planner.querySelector('input[name="' + name + '"][value="' + val + '"]'); if (el) el.checked = true; return el; }
    var qs = new URLSearchParams(location.search);
    if (qs.get('space')) { state.space = qs.get('space'); if (pick('space', state.space)) i = 1; }
    var svc = document.querySelector('[data-rx-service]');
    if (svc && !qs.get('space')) {
      var sp = svc.getAttribute('data-rx-space'), wt = svc.getAttribute('data-rx-want');
      if (sp && (!state.space || state.space === 'water' || state.space === 'unsure')) { state.space = sp; if (pick('space', sp)) i = 1; }
      if (wt && !(state.want || []).length) { state.want = [wt]; pick('want', wt); }
    }
    if (qs.get('want')) { state.want = [qs.get('want')]; pick('want', state.want[0]); }
    save(KEY_PLAN, state);

    function valid() { var s = steps[i]; return !s || !!s.querySelector('input:checked'); }
    function render() {
      steps.forEach(function (s, k) { if (k === i) s.setAttribute('data-active', ''); else s.removeAttribute('data-active'); });
      bars.forEach(function (b, k) { b.classList.toggle('on', k <= i); });
      if (i >= steps.length) { result.setAttribute('data-active', ''); nav.hidden = true; showResult(); count.textContent = 'Your suggestions'; }
      else { result.removeAttribute('data-active'); nav.hidden = false; count.textContent = 'Step ' + (i + 1) + ' of ' + steps.length; }
      back.disabled = i === 0; next.disabled = !valid();
      next.textContent = i === steps.length - 1 ? 'Show my suggestions' : 'Next';
    }
    function focusStep() { var el = i < steps.length ? steps[i].querySelector('legend') : result.querySelector('h3'); if (el) { el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); } }
    planner.addEventListener('change', function (e) {
      var inp = e.target; if (!inp.name || !inp.closest('.rx-step')) return;
      if (!started) { started = true; track('planner_started'); }
      var s = inp.closest('.rx-step');
      if (inp.type === 'checkbox') {
        var vals = [].map.call(s.querySelectorAll('input:checked'), function (x) { return x.value; });
        if (inp.value === 'unsure' && inp.checked) { s.querySelectorAll('input').forEach(function (x) { if (x !== inp) x.checked = false; }); vals = ['unsure']; }
        else if (inp.checked) { var u = s.querySelector('input[value="unsure"]'); if (u && u.checked) { u.checked = false; vals = vals.filter(function (v) { return v !== 'unsure'; }); } }
        state[inp.name] = vals;
      } else {
        state[inp.name] = inp.value;
        if (inp.name === 'budget') track('budget_selected', { budget: inp.value });
      }
      save(KEY_PLAN, state); next.disabled = !valid();
      if (inp.type === 'radio' && !reduce) setTimeout(function () { if (valid() && i < steps.length) { i++; render(); focusStep(); } }, 220);
    });
    next.addEventListener('click', function () { if (!valid()) return; i++; render(); focusStep(); });
    back.addEventListener('click', function () { if (i > 0) { i--; render(); focusStep(); } });
    planner.querySelector('[data-restart]').addEventListener('click', function () { i = 0; render(); focusStep(); });

    function showResult() {
      track('planner_completed', { space: state.space, budget: state.budget, area: state.area });
      var w = (state.want || []).filter(function (v) { return v !== 'unsure'; }).map(lab);
      planner.querySelector('.rx-result__summary').textContent = (state.space && state.space !== 'other' ? 'A ' + lab(state.space).toLowerCase() : 'Your space') +
        (w.length ? ' with ' + w.join(', ').toLowerCase() : '') +
        (state.area && state.area !== 'unsure' ? ', around ' + lab(state.area) : '') + '.';
      var picks = [], seen = {};
      function add(key) { var s = map.services && map.services[key]; if (s && s.url && !seen[key]) { seen[key] = 1; picks.push(s); } }
      add(state.space);
      (state.want || []).forEach(add);
      ((map.related && map.related[state.space]) || []).forEach(add);
      if (!picks.length) add('unsure');
      var box = planner.querySelector('.rx-result__cards'); box.innerHTML = '';
      picks.slice(0, 4).forEach(function (s) {
        var a = document.createElement('a'); a.href = s.url; a.setAttribute('data-rx-event', 'service_viewed'); a.setAttribute('data-rx-label', s.title);
        a.innerHTML = '<strong></strong><span></span>'; a.firstChild.textContent = s.title; a.lastChild.textContent = s.hint || 'See ideas and past work';
        box.appendChild(a);
      });
      var note = planner.querySelector('.rx-result__budget');
      var bn = map.budgetNotes && map.budgetNotes[state.budget];
      note.textContent = bn || ''; note.hidden = !bn;
      prefillForms();
    }
    render();
  })();

  /* inspiration likes */
  var likes = load(KEY_LIKES, []);
  var bar = document.querySelector('.rx-insp__bar');
  function renderLikes() {
    document.querySelectorAll('.rx-like').forEach(function (b) {
      var on = likes.indexOf(b.getAttribute('data-idea')) > -1;
      b.setAttribute('aria-pressed', on); b.textContent = on ? '\u2665 Saved' : '\u2661 I like this';
    });
    if (bar) {
      if (likes.length) bar.setAttribute('data-show', ''); else bar.removeAttribute('data-show');
      var c = bar.querySelector('[data-count]'); if (c) c.textContent = likes.length + (likes.length === 1 ? ' idea saved' : ' ideas saved');
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.rx-like'); if (!b) return;
    var idea = b.getAttribute('data-idea'), k = likes.indexOf(idea);
    if (k > -1) likes.splice(k, 1); else { likes.push(idea); track('inspiration_selected', { idea: idea }); }
    save(KEY_LIKES, likes); renderLikes(); prefillForms();
  });
  renderLikes();

  /* forms */
  function prefillForms() {
    var p = load(KEY_PLAN, {}), l = load(KEY_LIKES, []);
    document.querySelectorAll('[data-rx-form]').forEach(function (f) {
      function setSel(n, v) { var el = f.querySelector('select[name="contact[' + n + ']"]'); if (el && v && el.querySelector('option[value="' + v + '"]') && !el.dataset.touched) el.value = v; }
      setSel('property_type', p.space); setSel('area', p.area); setSel('budget', p.budget);
      if (p.want && p.want.length) setSel('service', p.want[0]);
      var city = f.querySelector('[name="contact[city]"]'); if (city && p.city && !city.value) city.value = p.city;
      var hidden = f.querySelector('[name="contact[planner_summary]"]');
      if (hidden) {
        hidden.value = [
          p.space ? 'Space: ' + lab(p.space) : '', p.want && p.want.length ? 'Wants: ' + p.want.map(lab).join(', ') : '',
          p.area ? 'Area: ' + lab(p.area) : '', p.budget ? 'Budget: ' + lab(p.budget) : '',
          l.length ? 'Liked ideas: ' + l.join(', ') : ''
        ].filter(Boolean).join(' | ');
      }
      var chips = f.querySelector('[data-rx-likes-list]');
      if (chips) { chips.textContent = l.length ? 'Ideas you saved: ' + l.join(', ') : ''; chips.hidden = !l.length; }
    });
  }
  document.querySelectorAll('[data-rx-form]').forEach(function (f) {
    var started = false;
    f.addEventListener('focusin', function () { if (!started) { started = true; track('form_started', { form: f.getAttribute('data-rx-form') }); } });
    f.addEventListener('change', function (e) {
      if (e.target.tagName === 'SELECT') e.target.dataset.touched = '1';
      if (e.target.name === 'contact[city]') { var p = load(KEY_PLAN, {}); p.city = e.target.value; save(KEY_PLAN, p); }
    });
    f.addEventListener('submit', function () { track('form_submitted', { form: f.getAttribute('data-rx-form') }); });
  });
  prefillForms();
  if (document.querySelector('[data-rx-form-success]')) track('form_submitted_confirmed', { page: location.pathname });

  var sv = document.querySelector('[data-rx-service]');
  if (sv) track('service_viewed', { service: sv.getAttribute('data-rx-service') });

  document.querySelectorAll('[data-rx-intent]').forEach(function (a) {
    a.addEventListener('click', function () {
      var p = load(KEY_PLAN, {}), v = a.getAttribute('data-rx-intent');
      if (v && v !== 'unsure') { p.space = a.getAttribute('data-space') || p.space; if (a.getAttribute('data-want')) p.want = [a.getAttribute('data-want')]; save(KEY_PLAN, p); }
      track('intent_selected', { intent: v });
    });
  });

  window.RX = RX;
})();
